/* =========================================================
   PURA ACTIVE — Custom JS
   Drop into assets/pura.js and load from theme.liquid
   ========================================================= */

(function () {
  'use strict';

  const WISHLIST_KEY = 'pura_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }

  function setWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  }

  function toggleWishlist(productId) {
    const list = getWishlist();
    const index = list.indexOf(productId);
    if (index > -1) list.splice(index, 1);
    else list.push(productId);
    setWishlist(list);
    updateWishlistCount();
    return index === -1;
  }

  function updateWishlistCount() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
    });
  }

  function initWishlistButtons() {
    const buttons = document.querySelectorAll('.pura-product-card__wishlist');
    const list = getWishlist();

    buttons.forEach((btn) => {
      const productId = btn.dataset.productId;
      if (productId && list.includes(productId)) {
        btn.classList.add('is-active');
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const id = this.dataset.productId;
        if (!id) return;
        const isAdded = toggleWishlist(id);
        this.classList.toggle('is-active', isAdded);
      });
    });

    updateWishlistCount();
  }

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (href.length <= 1) return;
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWishlistButtons();
      initSmoothScroll();
    });
  } else {
    initWishlistButtons();
    initSmoothScroll();
  }
})();
